import { useEffect, useState } from 'react';
import { ListboxOptions, Listbox, ListboxButton, ListboxOption } from '@headlessui/react';
import IconSvg from './ui/IconSvg';
import { useAccount } from 'wagmi';
import { useHttp } from 'src/hooks';
import { Network } from './cards/types/types';
import { getIconName } from 'src/utils/networkIcon';

const ChooseNetwork = () => {
  const { address } = useAccount();
  const { sendRequest } = useHttp();
  const [networks, setNetworks] = useState<Network[]>([]);
  const [selectedNetwork, setSelectedNetwork] = useState<Network | null>(null);

  const getNetworks = () => {
    sendRequest(
      {
        url: 'networks',
        method: 'GET',
      },
      (data: any) => {
        setNetworks(data);
        if (!selectedNetwork && data.length > 0) {
          setSelectedNetwork(data[0]);
        }
      },
    );
  };

  // Fetch networks when the address changes
  useEffect(() => {
    if (address) {
      getNetworks();
    }
  }, [address]);

  return (
    <>
      {address && (
        <Listbox value={selectedNetwork} onChange={setSelectedNetwork}>
          <ListboxButton
            className={`group w-[114px] bg-grayscale-800 flex justify-between items-center py-1.5 px-1.5 rounded-[11px] data-[open]:rounded-b-[0px]`}
          >
            <div className="inline-flex items-center gap-1">
              <IconSvg
                icon="avaxS"
                className="text-gray-200"
              />

              <span className="text-xs text-grayscale-200">
               Avax
                {/* {selectedNetwork?.networkCurrency || 'Select Network'} */}
              </span>
            </div>

            <IconSvg
              icon="arrowDownS"
              className="text-grayscale-200 group-data-[open]:rotate-180 transition-all duration-300"
            />
          </ListboxButton>

          <ListboxOptions
            anchor={{ to: 'bottom', gap: -3 }}
            className={`group z-10 w-[var(--button-width)] bg-grayscale-800 rounded-[11px] cursor-pointer data-[open]:rounded-t-[0px] flex flex-col`}
          >
            {/* {networks
              .filter(network => network.id !== selectedNetwork?.id)
              .map(network => ( */}
            <>
              {[
                { id: 1, name: 'Avax', icon: 'avaxS', badge: false },
                { id: 2, name: 'ETH', icon: 'ethS', badge: true },
                { id: 3, name: 'EGLD', icon: 'egld', badge: true },
              ].map(network => (
                <ListboxOption
                  key={network.id}
                  value={network.name}
                  className={`inline-flex items-center py-1.5 px-2 gap-1`}
                >
                  {/* Network Icon */}
                  <IconSvg icon={network.icon} className="text-gray-200 w-4" />

                  {/* Network Name */}
                  <span className="text-xs text-grayscale-200">{network.name}</span>

                  {/* "Soon" Badge */}
                  {network.badge && (
                    <span className="text-[8px] text-white bg-[#EDA926] px-1 py-0.5 rounded-md ml-2">
                      Soon
                    </span>
                  )}
                </ListboxOption>
              ))}
            </>
            {/* ))} */}
          </ListboxOptions>
        </Listbox>
      )}
    </>
  );
};

export default ChooseNetwork;
